module.exports = __webpack_public_path__ + "19-lined-68e67b6cb653dcb9547bb58bab688937.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/step-number-icons/lined/19-lined.svg
// module id = 129
// module chunks = 0